import { Component, Injector, forwardRef } from '@angular/core';
import {
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    UntypedFormControl
} from '@angular/forms';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-phone2',
    templateUrl: './input-phone2.component.html',
    styleUrls: [
        '../input.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputPhone2Component),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => InputPhone2Component),
            multi: true,
        }
    ],
    standalone: false
})
export class InputPhone2Component extends InputBase<string>
{
    // * https://regexr.com/4lnuf
    private static phoneRegexp = /^[-+ .\d]*$/;
    private static identifier: number = 0;

    constructor (
        injector: Injector
    )
    {
        super(injector);

        this.fieldId = `input-phone2-${InputPhone2Component.identifier++}-id`;
    }

    validate ({ value }: UntypedFormControl)
    {
        if (value)
        {
            return value.match(InputPhone2Component.phoneRegexp) ? null : { 'phoneNumber': true };
        }
    }
}
